import { render, staticRenderFns } from "./LogIn.vue?vue&type=template&id=5ddfe4d1&scoped=true&"
import script from "./LogIn.vue?vue&type=script&lang=js&"
export * from "./LogIn.vue?vue&type=script&lang=js&"
import style0 from "./../assets/css/LoginRegist.css?vue&type=style&index=0&id=5ddfe4d1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfe4d1",
  null
  
)

export default component.exports